export default __webpack_public_path__ + "static/media/coveredBulb.742f5856.svg";